import { makeStyles } from '@mui/styles'
import {
  CHARCOAL,
  GAINSBORO_BORDER,
  GUNMETAL,
  MEDIUM_GRAY,
  MIDNIGHT_EXPRESS,
  NEON_BLUE_LIGHT,
  RAVEN,
  SHAMROCK,
  SILVER_SAND,
  WHITE,
} from '@returnmates/client-core/src/constants/colors'
import { URBANIST } from '@returnmates/ui-core/src/constants/styles/fonts'

const useStyles = makeStyles(() => ({
  detailsRow: {
    display: 'flex',
    alignItems: 'center',
    '&:not(:first-child)': {
      marginTop: 3,
    },
  },
  carrierDetailsRow: {
    flexDirection: 'column',
  },
  detailsGroupField: {
    marginTop: 10,
  },
  inputHead: {
    flexShrink: 0,
    fontFamily: URBANIST,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '140%',
    letterSpacing: 0.2,
    width: '30%',
    marginRight: 10,
    color: CHARCOAL,
  },
  input: {
    '& > div': {
      borderColor: 'transparent',
      '& > input': {
        fontFamily: URBANIST,
        color: MIDNIGHT_EXPRESS,
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '160%',
      },
    },
  },
  descriptionInput: {
    height: 74,
    '& div': {
      height: '100%',
      '& textarea:first-of-type': {
        height: '100% !important',
        boxSizing: 'border-box',
      },
    },
  },
  spinner: {
    position: 'relative',
    minHeight: 300,
  },
  link: {
    fontFamily: URBANIST,
    color: NEON_BLUE_LIGHT,
    textDecoration: 'underline',
    fontWeight: 500,
    fontSize: 14,
    cursor: 'pointer',
  },
  formControlLabelRoot: {
    marginRight: 35,
  },
  formControlLabel: {
    fontFamily: URBANIST,
    color: MIDNIGHT_EXPRESS,
    fontSize: 14,
    lineHeight: '130%',
    marginLeft: 5,
  },
  selectWrapper: {
    width: '100%',
    position: 'relative',
  },
  selectField: {
    border: '2px solid transparent',
    borderRadius: 5,
    width: '100%',
    '&:hover': {
      border: `2px solid ${NEON_BLUE_LIGHT}`,
    },
    '&.Mui-focused': {
      border: `2px solid ${NEON_BLUE_LIGHT}`,
    },
  },
  selectWrap: {
    marginTop: 3,
  },
  boldTitle: {
    fontWeight: 600,
    color: MIDNIGHT_EXPRESS,
  },
  closeButton: {
    cursor: 'pointer',
    alignSelf: 'flex-start',
  },
  receiveButton: {
    marginLeft: 10,
    width: 150,
  },
  statusSelect: {
    width: '100%',

    '& > div': {
      alignItems: 'center',
      display: 'flex',
    },
  },
  inputHeaderWrap: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  addButton: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: URBANIST,
    color: NEON_BLUE_LIGHT,
    fontSize: 14,
    lineHeight: '150%',
    marginBottom: 10,
    cursor: 'pointer',
    '& svg': {
      marginRight: 6,
      marginBottom: 1,
    },
  },
  newRetailerModal: {
    position: 'absolute',
    top: 30,
    backgroundColor: '#FFFFFF',
    border: `1px solid ${SILVER_SAND}`,
    boxShadow: '0px 19px 24px rgba(0, 0, 0, 0.12)',
    borderRadius: 8,
    zIndex: 2,
    padding: 20,
    width: '100%',
    height: 'fit-content',
  },
  newRetailerModalTitle: {
    fontFamily: URBANIST,
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '160%',
    color: MIDNIGHT_EXPRESS,
    marginBottom: 15,
  },
  modalButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 17,
  },
  errorSpace: {
    marginTop: 30,
  },
  labelTypeWrap: {
    display: 'flex',
    alignItems: 'center',
  },
  labelTitle: {
    marginBottom: 0,
  },
  swapCheckbox: {
    display: 'flex',
    alignItems: 'center',
  },
  noLabelButton: {
    marginBottom: 10,
    fontSize: 12,
    color: NEON_BLUE_LIGHT,
    fontFamily: URBANIST,
    cursor: 'pointer',
  },
  detailsDataRow: {
    '&:not(:first-child)': {
      marginTop: 3,
    },
  },
  detailsType: {
    fontFamily: URBANIST,
    fontSize: 13,
    lineHeight: '150%',
    color: RAVEN,
    width: 100,
    display: 'inline-block',
    verticalAlign: 'top',
    overflowWrap: 'break-word',
  },
  detailsData: {
    display: 'inline-block',
    maxWidth: 'calc(100% - 120px)',
    fontFamily: URBANIST,
    fontWeight: 500,
    fontSize: 13,
    lineHeight: '160%',
    color: MIDNIGHT_EXPRESS,
    paddingLeft: 30,
    overflowWrap: 'break-word',
  },
  optionPrimary: {
    fontFamily: URBANIST,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '160%',
    color: MIDNIGHT_EXPRESS,
    cursor: 'pointer',
  },
  optionSecondary: {
    fontWeight: 500,
    fontSize: 13,
  },
  inputRoot: {
    width: '100%',
  },
  hidePopupIcon: {
    display: 'none',
  },
  customCloseWrapper: {
    position: 'relative',
  },
  closeIcon: {
    position: 'absolute',
    right: 5,
    top: 42,
  },
  checkbox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 3,
  },
  inputHeadCheckbox: {
    width: 'fit-content',
    flexShrink: 0,
    fontFamily: URBANIST,
    fontSize: 14,
    color: RAVEN,
  },
  boxRequiredTitle: {
    marginLeft: 15,
  },
  modalWrapper: {
    padding: '55px 25px 15px',
    overflowX: 'hidden',
  },
  missingLabelTitile: {
    fontFamily: URBANIST,
    fontWeight: 600,
    fontSize: 30,
    lineHeight: '36px',
    textAlign: 'center',
    color: MIDNIGHT_EXPRESS,
  },
  missingLabelText: {
    fontFamily: URBANIST,
    fontWeight: 275,
    fontSize: 16,
    lineHeight: '24px',
    textAlign: 'center',
    marginTop: '25px',
    color: RAVEN,
  },
  missingLabelModalButtons: {
    display: 'grid',
    marginTop: '40px',
    gridTemplateColumns: '1fr 1fr',
  },
  multiPackageModalButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginTop: '40px',
  },
  multiPackageModalButton: {
    width: '100%',
    height: '40px',
  },
  missingLabelButton: {
    width: '193px',
    height: '40px',
  },
  requiresAgeVerificationLabel: {
    marginLeft: 10,
  },
  requiresDeliverySignatureCheckbox: {
    marginLeft: 15,
  },
  datePicker: {
    '& > div': {
      border: '2px solid transparent',
    },
  },
  disabledDate: {
    '&:hover > div': {
      pointerEvents: 'none',
    },
  },
  dimensionsContainer: {
    display: 'flex',
    gap: 5,
  },
  scanDate: {
    whiteSpace: 'nowrap',
  },
  userEmailCell: {
    maxWidth: 100,
    cursor: 'pointer !important',
  },
  userEmail: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  selectorContainer: {
    display: 'flex',
    gap: 1,
  },
  activeSelectorButton: {
    backgroundColor: SHAMROCK,
    color: WHITE,
    padding: '3px 10px 3px 10px',
  },
  inactiveSelectorButton: {
    backgroundColor: MEDIUM_GRAY,
    color: WHITE,
    padding: '3px 10px 3px 10px',
  },
  rightSelectorButton: {
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
  },
  leftSelectorButton: {
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
  },
  id: {
    maxWidth: '70%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    fontFamily: URBANIST,
    fontSize: 14,
    lineHeight: '120%',
    letterSpacing: 0.2,
  },
  idContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 5,
  },
  idActions: {
    display: 'flex',
    gap: 10,
    alignItems: 'center',

    '& > svg': {
      cursor: 'pointer',
      opacity: 0.4,

      '&:hover': {
        opacity: 1,
      },
    },
  },
  table: {
    borderCollapse: 'collapse',
  },
  tableHead: {
    width: '100%',
    height: 'auto',
    border: 'none',
  },
  headerRow: {
    backgroundColor: 'RGBA(189, 189, 189, 0.2)',
    borderBottom: `1px solid RGBA(189, 189, 189, 0.2)`,

    '&:hover': {
      backgroundColor: 'RGBA(189, 189, 189, 0.2)',
      borderBottom: `1px solid RGBA(189, 189, 189, 0.2)`,
    },
  },
  headerCell: {
    color: 'RGBA(2, 2, 2, 0.2)',
    padding: 5,
    fontFamily: URBANIST,
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '130%',
  },
  tableRow: {
    border: 'none',
    cursor: 'auto',
  },
  bodyCell: {
    padding: 5,
    borderBottom: `1px solid ${GAINSBORO_BORDER}`,
    color: GUNMETAL,
    fontFamily: URBANIST,
    fontSize: 13,
    fontWeight: 400,
    lineHeight: '130%',
  },
  buttonsContainer: {
    position: 'fixed',
    width: '30%',
    bottom: 0,
    background: WHITE,
    borderTop: `1px solid ${GAINSBORO_BORDER}`,
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 -10px',
    padding: 10,
  },
  button: {
    padding: '0 10px',
    fontFamily: URBANIST,
    letterSpacing: 0.2,
    fontSize: 14,
    lineHeight: '140%',
    fontWeight: 700,
    height: 40,
    border: 'none',
    borderRadius: 4,

    '&:hover': {
      opacity: 0.8,
    },
  },
  cancelButton: {
    backgroundColor: MEDIUM_GRAY,
    color: WHITE,

    '&:hover': {
      backgroundColor: MEDIUM_GRAY,
      border: 'none',
    },
  },
  saveButton: {
    backgroundColor: NEON_BLUE_LIGHT,
    color: WHITE,

    '&:hover': {
      backgroundColor: NEON_BLUE_LIGHT,
      border: 'none',
    },
  },
  noWrapText: {
    whiteSpace: 'nowrap',
  },
  idsContainer: {
    marginBottom: 10,
  },
  trackingIdCell: {
    maxWidth: 100,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  lastScannedDate: {
    fontFamily: URBANIST,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '130%',
    paddingLeft: 7,
  },
}))

export default useStyles
